import "@/styles/main.scss";
import "vue-final-modal/style.css";
import "./extensions";
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./vuetify.js";
import VueSidebarMenu from "vue-sidebar-menu";
import { store } from "@/store";
import appPlugin from "@/plugins/app.plugin";

import appFilterPlugin from "@/plugins/app-filter.plugin";
import veeValidatePlugin from "@/plugins/vee-validate.plugin";
import appErrorHandler from "@/error/app-error-handler";

const app = createApp(App);

app.use(store);
app.use(vuetify);
app.use(VueSidebarMenu);
app.use(router);
app.use(appPlugin, { store });
app.use(veeValidatePlugin);
app.use(appFilterPlugin);

app.config.errorHandler = appErrorHandler;

(async () => {
  const tokenId = new URLSearchParams(window.location.search).get("tokenid");
  if (tokenId) {
    await store.dispatch("user/login", { tokenId });
    window.history.replaceState(null, "", "/");
  }
  app.mount("#app");
})();
